import React from 'react';
import { Briefcase, Baby, Utensils, Sofa, BedDouble, Building2 } from 'lucide-react';

import commercialImg from 'images/comercialspace.jpg';
import kidsImg from 'images/kidsspace.jpg';
import kitchenImg from 'images/kitchenspace.jpg';
import livingImg from 'images/livingspace.jpg';
import masterImg from 'images/bedroomspace.jpg';
import officeImg from 'images/officespace.jpg';

const categories = [
  { title: 'Commercial Spaces', image: commercialImg, icon: <Briefcase size={40} /> },
  { title: 'Kids Room', image: kidsImg, icon: <Baby size={40} /> },
  { title: 'Kitchen', image: kitchenImg, icon: <Utensils size={40} /> },
  { title: 'Living Room', image: livingImg, icon: <Sofa size={40} /> },
  { title: 'Master Bedroom', image: masterImg, icon: <BedDouble size={40} /> },
  { title: 'Office', image: officeImg, icon: <Building2 size={40} /> },
];

const Service = () => {
  return (
    <section className="w-full mt-20 px-4">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-4xl  font-semibold text-black mb-10">
          Spaces We  <span className="text-primary">Style</span>
        </h2>
        <p className="text-gray-600 max-w-2xl text-center mb-10 mx-auto text-sm md:text-base">
         From cozy bedrooms to modern offices, find laminate inspirations crafted for each room.Elevate every corner of your space with designs that blend style and functionality.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {categories.map((cat, index) => (
          <div
            key={index}
            className="relative h-64 group overflow-hidden rounded-xl shadow-lg"
            style={{ backgroundImage: `url(${cat.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className="absolute inset-0 bg-black/50 group-hover:bg-black/60 transition duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white z-10">
              <div className="mb-3 text-white">{cat.icon}</div>
              <h3 className="text-xl font-semibold">{cat.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Service;
